export const mechanicalData = {
  departmentName: "Department of Mechanical Engineering",
  bannerImage: "/infrastructure/mechanics/lab-7.JPG",
  
  about: {
    title: "About the Department",
    content: `The Department of Mechanical Engineering at Rayalaseema University is dedicated to providing comprehensive 
    education in mechanical sciences and engineering. Our programs cover thermodynamics, fluid mechanics, manufacturing 
    processes, design, robotics, and renewable energy systems. With a focus on both fundamental principles and modern 
    technologies, we prepare students for diverse careers in automotive, aerospace, manufacturing, and energy sectors.`,
    highlights: [
      "Advanced manufacturing and CAD/CAM laboratories",
      "Thermal engineering and fluid mechanics labs",
      "Research in renewable energy and sustainable manufacturing",
      "Industry collaborations and internship opportunities"
    ]
  },

  brochure: {
    title: "Department Brochure",
    pdfLink: "/mechanical/department-brochure.pdf",
    description: "Download our comprehensive department brochure for detailed information about programs, facilities, and achievements."
  },

  hod: {
    id:'mech001',
    name: "A. Sreekanth",
    designation: "Co-ordinator & Assistant Professor (Ad hoc)",
    email: "sreekanth.mec@ruce.ac.in",
    mobile: "+91 96520 32966",
    photo: "/mechanics/sreekanth.JPG",
    qualification: "B.Tech, M.Tech, Ph.D (Pursuing)",
    specialization: "Advanced Manufacturing Systems",
    profileLink: "/mechanics/sreekanth.pdf",
    message: `Welcome to the Department of Mechanical Engineering. We are committed to excellence in mechanical 
    engineering education and research. Our goal is to develop skilled engineers who can innovate and contribute 
    to the advancement of mechanical technologies for a sustainable future.`,
   
  },

  bos: {
    title: "Board of Studies",
    members: [
      // {
      //   name: "Prof. Ravi Kiran",
      //   designation: "Chairman",
      //   affiliation: "Rayalaseema University"
      // },
      // {
      //   name: "Dr. Srinivas Reddy",
      //   designation: "Member",
      //   affiliation: "Rayalaseema University"
      // },
      // {
      //   name: "Dr. Venkata Rao",
      //   designation: "Member",
      //   affiliation: "Rayalaseema University"
      // },
      // {
      //   name: "Prof. External Expert",
      //   designation: "External Member",
      //   affiliation: "Industry Partner"
      // }
    ]
  },

  faculty: [
    {
      id:'mech001',
    name: "A. Sreekanth",
    designation: "Co-ordinator & Assistant Professor (Ad hoc)",
    email: "sreekanth.mec@ruce.ac.in",
    mobile: "+91 96520 32966",
    photo: "/mechanics/sreekanth.JPG",
    qualification: "B.Tech, M.Tech, Ph.D (Pursuing)",
    specialization: "Advanced Manufacturing Systems",
    profileLink: "/mechanics/sreekanth.pdf"
  },
 
  {
    id:'mech003',
    name: "Bandaru Venkata Siva Prasad Reddy (Ad hoc)",
    designation: "Assistant Professor (Ad hoc)",
    email: "sivaprasad.mec@ruce.ac.in",
    mobile: "+91 73824 40309",
    photo: "/mechanics/shivaprasad.JPG",
    qualification: "B.Tech, M.Tech, Ph.D (Pursuing)",
    specialization: "Production Engineering, Functionally Graded Composite Materials, 3D Printing",
    profileLink: "/mechanics/shivaprasad.pdf"
  },
   {
    id:'mech002',
    name: "T. Gayatri",
    designation: "Assistant Professor (Ad hoc)",
    email: "gayatrigopal.mec@ruce.ac.in",
    mobile: "+91 99021 45149",
    photo: "/mechanics/Gayatri.JPG",
    qualification: "B.Tech, M.Tech, Ph.D (Pursuing)",
    specialization: "Thermal Engineering",
    profileLink: "/mechanics/Gayatri.pdf"
  },
  
]
  ,

  courses: {
    undergraduate: [
      {
        name: "B.Tech Mechanical Engineering",
        duration: "4 Years",
        eligibility: "10+2 with Physics, Chemistry, and Mathematics",
        intake: "120 seats"
      }
    ],
    // postgraduate: [
    //   {
    //     name: "M.Tech Thermal Engineering",
    //     duration: "2 Years",
    //     eligibility: "B.E./B.Tech in Mechanical Engineering",
    //     intake: "30 seats"
    //   },
    //   {
    //     name: "M.Tech Machine Design",
    //     duration: "2 Years",
    //     eligibility: "B.E./B.Tech in Mechanical Engineering",
    //     intake: "30 seats"
    //   }
    // ],
    // research: [
    //   {
    //     name: "Ph.D. in Mechanical Engineering",
    //     duration: "Minimum 3 Years",
    //     eligibility: "M.Tech with qualifying exam",
    //     areas: "Thermal Engineering, Manufacturing, Design, Robotics, Renewable Energy"
    //   }
    // ]
  },

  Infrastructure: [
  // "/infrastructure/mechanics/class-1.JPG",
  "/infrastructure/mechanics/class-2.JPG",
  
  "/infrastructure/mechanics/lab-1.JPG",
  "/infrastructure/mechanics/lab-4.JPG",
  "/infrastructure/mechanics/lab-2.JPG",
  "/infrastructure/mechanics/lab-3.JPG",

  "/infrastructure/mechanics/lab-5.JPG",
  "/infrastructure/mechanics/lab-6.JPG",
  "/infrastructure/mechanics/lab-7.JPG",
  
]
};
